var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"icon":"","text":""},on:{"click":function($event){return _vm.$emit('close', false)}}},[_c('iconify-icon',{staticClass:"iconify text-h5",attrs:{"data-icon":"mdi-close"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }